import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import ListingStatusesActions from 'components/ListingStatusesActions';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import Can from 'components/Can';
import { DashboardOutlined } from '@material-ui/icons';

const ActionsList = ({ isAtacchingFiles }) => {
  const defaultFilters = {
    __fiscal_year: '',
    __period_id: '',
    __start_date: '',
    __end_date: '',
    per_page: 10,
    page:1
  };

  const [data, setData] = useState({ data: [], pagination:{} });
  const [filters, setFilters] = useState(defaultFilters);

  const [companies, setCompanies] = useState([]);
  const [steps, setSteps] = useState([]);
  const [fiscalYears, setFiscalYears] = useState([]);
  const [periodTypes, setPeriodTypes] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    api.get('companies/all').then(({ data }) => setCompanies(data));

    api.get('flows/1/actions-count').then(({ data }) => {
      setSteps(data.steps);
    });

    api
      .get('company-rules/fiscal-years')
      .then(({ data }) => setFiscalYears(data));

    api.get('period-types').then(({ data }) => {
      setPeriodTypes(data)
    });
  }, []);
  
  useEffect(() => {
    getActions()
  }, [filters]);

  const getActions = () => {
    api.get('actions', { params: { ...filters } })
      .then(({ data }) => {
        setData(data);
      });
  }

  const toDbDate = date => date.toISOString().substring(0,10)

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:actions list')}</h4>
          </Col>
        </Row>
        <Row className="ml-4">
          <Col md={3}>
            <Form.Group>
              <Can do="createAction" on="App">
                <Form.Label style={{ display: 'block' }}>&nbsp;</Form.Label>
                <Button size="sm" className="login-btn mr-1" variant="primary-login" as={Link} to="/actions/create">
                  <i className="fas fa-plus"></i> {t('label:add new')}
                </Button>
              </Can>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <ListingStatusesActions
              statuses={steps.map((step) => ({
                ...step.status,
                ...{ count: step.actions_count },
              }))}
              filters={[
                {
                  name: 'fiscal year',
                  key: '__fiscal_year',
                  options: fiscalYears.map(({ fiscal_year }) => {
                    return { label: fiscal_year, value: fiscal_year };
                  }),
                },
                {
                  name: 'period',
                  key: '__period_id',
                  options: (() => {
                    const will_return = [];

                    periodTypes.forEach((periodType) => {
                      periodType.periods.forEach((period) => {
                        will_return.push({
                          label: `${periodType.name} ${period.position}`,
                          value: period.id,
                        });
                      });
                    });

                    return will_return;
                  })(),
                },
                {
                  name: 'company',
                  key: '__company_id',
                  options: companies.map((company) => ({
                    label: company.alias,
                    value: company.id,
                  })),
                },
              ]}
              // setFilters={setFilters}
              stateFilters={filters}
              data={data}
              handleFilterChange={handleFilterChange}
              isAtacchingFiles={isAtacchingFiles}
            />
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export { ActionsList };
export default MasterPage(ActionsList);
